import React, { useEffect, useState } from 'react';
import { apiGet, apiPost } from '../../lib/api';
import { toast } from 'sonner';

export default function AdminMerchants() {
  const [list, setList] = useState([]);
  const load = () => apiGet('/admin/merchants').then(r => setList(r.data || []));
  useEffect(() => { load(); }, []);
  const act = async (id, action) => {
    await apiPost(`/admin/merchants/${id}/${action}`);
    toast.success(`Merchant ${action}d`);
    load();
  };
  return (
    <div className="space-y-4" data-testid="admin-merchants">
      <h1 className="font-heading font-extrabold text-3xl text-rozops-navy">Merchants</h1>
      <div className="bg-white rounded-2xl border border-gray-100 shadow-soft overflow-x-auto">
        <table className="w-full">
          <thead className="bg-rozops-bg border-b border-gray-100">
            <tr className="text-left text-xs uppercase tracking-wider text-rozops-text-muted font-bold">
              <th className="py-3 px-6">Business</th><th className="py-3 px-6">Owner</th><th className="py-3 px-6">City</th><th className="py-3 px-6">Plan</th><th className="py-3 px-6">Status</th><th className="py-3 px-6"></th>
            </tr>
          </thead>
          <tbody>
            {list.length === 0 && <tr><td colSpan={6} className="py-10 text-center text-rozops-text-muted">No merchants yet.</td></tr>}
            {list.map(b => (
              <tr key={b.id} className="border-b border-gray-50" data-testid={`merchant-${b.id}`}>
                <td className="py-4 px-6 font-semibold">{b.business_name}</td>
                <td className="py-4 px-6 text-sm text-rozops-text-muted">{b.owner?.email}</td>
                <td className="py-4 px-6 text-sm">{b.city || '—'}</td>
                <td className="py-4 px-6 text-sm capitalize">{b.subscription_plan}</td>
                <td className="py-4 px-6"><span className={`px-2.5 py-1 rounded-full text-xs font-bold ${b.status === 'active' ? 'bg-rozops-green-light text-rozops-green' : b.status === 'suspended' ? 'bg-red-50 text-red-500' : 'bg-amber-50 text-amber-700'}`}>{b.status}</span></td>
                <td className="py-4 px-6 text-right whitespace-nowrap">
                  {b.status !== 'active' && <button onClick={() => act(b.id, 'approve')} className="text-rozops-green mr-3 text-sm font-semibold">Approve</button>}
                  {b.status === 'active' && <button onClick={() => act(b.id, 'suspend')} className="text-red-500 text-sm font-semibold">Suspend</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
